import { transcriptSchema } from './schema';

import type { TranscriptItem } from './types';

export const normalizeTranscript = async (
  raw: unknown,
): Promise<TranscriptItem[]> => {
  const { Transcript } = await transcriptSchema.validate(raw, {
    stripUnknown: true,
  });
  return Transcript.map((item) => {
    return {
      beginOffsetSeconds: Math.floor(item.BeginOffsetMillis / 1000),
      endOffsetSeconds: Math.floor(item.EndOffsetMillis / 1000),
      text: item.Content,
      role: item.ParticipantId,
    };
  });
};
